// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__12GVm","message":"styles_message__3l9wM","container":"styles_container__1lgle"};